import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createNewPromotion, getProductByCategory, updatePromotion } from "../../../../action";
import { GlobalState } from "../../../../GlobalState";
import { TabTitle } from "../../../../util/titleChanger";
import { ToastContainer, toast } from "react-toastify";
import { sendPushNotification } from "../../../../util/notification";

export default function PromotionForm() {
  const { promotionId } = useParams();
  TabTitle(promotionId > 0 ? "Update Promotion" : "Add Promotion");
  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  //Import promotions state from global state below
  const [promotionDetail] = state.promotionAPI.promotionDetail;
  const [promoId, setPromoId] = state.promotionAPI.promoId;
  const [callback, setCallback] = state.promotionAPI.callback;

  //Import Stock states from global state
  const [stocks] = state.stockAPI.stocks;

  //Import category state form global state below
  const [allCategories] = state.categoryAPI.allCategories;
  const [categoryId, setCategoryId] = useState("");

  //Import product state from global state
  const [productData, setProductData] = useState([]);
  const [productsList] = state.productAPI.productsList;

  //For auto complete state
  const [showCategorySuggestions, setShowCategorySuggestions] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const categorySuggestions = allCategories.filter((category) => category.name.toString().toLowerCase().includes(selectCategory.toString().toLowerCase()));

  const [showProductSuggestions, setShowProductSuggestions] = useState(false);
  const [selectProduct, setSelectProduct] = useState("");
  const productSuggestions = productData.filter((product) => product.name.toString().toLowerCase().includes(selectProduct.toString().toLowerCase()));

  //Local State
  const [btnName, setBtnName] = useState("Save");
  const [focused, setFocused] = useState(false);
  const [values, setValues] = useState([]);

  //Get value form input elements and assign into values states
  const onChangeValue = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleCategorySuggestionClick = (suggestion) => {
    setSelectCategory(suggestion.name);
    setShowCategorySuggestions(false);
    setCategoryId(suggestion.id);
    setValues({
      ...values,
      categoryId: suggestion.id,
    });

    getProductByCategory(suggestion.id, (res) => {
      setProductData(res.data);
    });
  };

  const onChangeSelectCategory = (e) => {
    setSelectCategory(e.target.value);
  };

  const handleProductSuggestionClick = (suggestion) => {
    setSelectProduct(suggestion.name);
    setShowProductSuggestions(false);
    setValues({
      ...values,
      productId: suggestion.id,
    });
  };

  const onChangeSelectProduct = (e) => {
    setSelectProduct(e.target.value);
  };

  const handleFocus = (e) => {
    setFocused(true);
  };

  useEffect(() => {
    if (promotionId > 0) {
      setPromoId(promotionId);
      setBtnName("Update");

      var today = new Date();
      var valid_from_date = new Date(promotionDetail.valid_from_date);
      var valid_end_date = new Date(promotionDetail.valid_end_date);

      setValues({
        tag: promotionDetail ? promotionDetail.tag : "",
        valid_from_date: promotionDetail.valid_from_date ? valid_from_date.toISOString().substring(0, 10) : today.toISOString().substring(0, 10),
        valid_end_date: promotionDetail.valid_end_date ? valid_end_date.toISOString().substring(0, 10) : today.toISOString().substring(0, 10),
        price_type: promotionDetail ? promotionDetail.price_type : "",
        note: promotionDetail ? promotionDetail.note : "",
        productId: promotionDetail.product ? promotionDetail.product.id : "1",
        categoryId: promotionDetail.product ? promotionDetail.product.category.id : "1",
      });

      productsList.data.map((product) => {
        const product_id = promotionDetail.product ? promotionDetail.product.id : "1";

        if (product.id === product_id) {
          setSelectProduct(product.name);
          setSelectCategory(product.category.name);
        }
      });
    }
  }, [productsList, allCategories, promoId, promotionId, promotionDetail]);

  const submitDefault = (e) => {
    e.preventDefault();

    const price = stocks.filter((stock) => stock.productId === values.productId);

    const offerPrice = parseFloat(price[0].unit_selling_price) - parseFloat(values.price_type);

    const promotionInfo = {
      tag: values.tag,
      valid_from_date: values.valid_from_date || new Date().toISOString().substring(0, 10),
      valid_end_date: values.valid_end_date || new Date().toISOString().substring(0, 10),
      promotion_price: offerPrice.toString(),
      price_type: values.price_type,
      note: values.note,
      updatedBy: signInUser.id,
      old_price: price[0].unit_selling_price.toString(),
      productId: values.productId,
    };

    if (promotionId > 0) {
      updatePromotion(promotionId, promotionInfo, (res) => {
        if (res.status === 200) {
          sendPushNotification();
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    } else {
      promotionInfo.createdBy = signInUser.id;
      createNewPromotion(promotionInfo, (res) => {
        if (res.status === 200) {
          sendPushNotification();
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    }
  };

  return (
    <div className="form-container">
      <header>Product Form</header>
      <form onSubmit={submitDefault} className="form">
        <div className="input-box">
          <label htmlFor="categoryId">Category</label>
          <input
            type="text"
            name="categoryId"
            id="categoryId"
            placeholder="Enter Category Name"
            value={selectCategory}
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeSelectCategory}
            onFocus={() => setShowCategorySuggestions(true)}
          />
          {showCategorySuggestions && (
            <ul className="suggestions">
              {categorySuggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleCategorySuggestionClick(suggestion)}>
                  {suggestion.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="input-box">
          <label htmlFor="productId">Product Name</label>
          <input
            type="text"
            name="productId"
            id="productId"
            placeholder="Enter Product Name"
            value={selectProduct}
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeSelectProduct}
            onFocus={() => setShowProductSuggestions(true)}
          />
          {showProductSuggestions && (
            <ul className="suggestions">
              {productSuggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleProductSuggestionClick(suggestion)}>
                  {suggestion.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="input-box">
          <label htmlFor="tag">Tag</label>
          <input type="text" name="tag" id="tag" placeholder="Enter Tag" value={values.tag || ""} onChange={onChangeValue} />
        </div>

        <div className="input-box">
          <label htmlFor="valid_from_date">Valid From</label>
          <input type="date" name="valid_from_date" id="valid_from_date" value={values.valid_from_date || new Date().toISOString().substring(0, 10)} onChange={onChangeValue} />
        </div>

        <div className="input-box">
          <label htmlFor="valid_end_date">Valid End</label>
          <input type="date" name="valid_end_date" id="valid_end_date" value={values.valid_end_date || new Date().toISOString().substring(0, 10)} onChange={onChangeValue} />
        </div>

        <div className="input-box">
          <label htmlFor="price_type">Discount Amount</label>
          <input type="text" name="price_type" id="price_type" placeholder="Enter Discount Amount" value={values.price_type || ""} onChange={onChangeValue} />
        </div>

        <div className="input-box">
          <label htmlFor="note">Description</label>
          <textarea name="note" id="note" cols="30" rows="5" placeholder="Enter description here..." value={values.note || ""} onChange={onChangeValue} />
        </div>

        <div className="form-button">
          <button className="add_new">{btnName}</button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}
